<template>
    <div>
        <emails-panel/>
        <footers-panel/>
    </div>
</template>

<script>
    import EmailsPanel from "../components/Emails/EmailsPanel";
    import FootersPanel from "../components/Footers/FootersPanel";
    import SystemNotificator from "@/services/SystemNotificator";

    // Kody, z którymi DealerX wraca z podłączania skrzynki OAuth (OAuthMailboxController::callback).
    const OAUTH_ERRORS = [
        'mailbox_not_available',
        'authentication_failed',
        'connection_error',
        'no_refresh_token',
        'no_email',
        'invalid_state',
        'google_keys_missing',
    ];

    export default {
        name: "EmailBoxes",
        components: { FootersPanel, EmailsPanel },

        created() {
            this.notifyOAuthResult();
        },

        methods: {
            // Wynik podłączania skrzynki przez Gmail/Microsoft przychodzi w query (redirect z DealerX).
            // Komunikat zamiast surowego błędu, query czyszczone, żeby odświeżenie go nie powtórzyło
            // (CU-1amhxucm5jx).
            notifyOAuthResult() {
                const { mailboxError, mailboxConnected, ...query } = this.$route.query;

                if (mailboxError === undefined && mailboxConnected === undefined) {
                    return;
                }

                if (mailboxError !== undefined) {
                    const code = OAUTH_ERRORS.includes(mailboxError) ? mailboxError : 'unknown';
                    SystemNotificator.error({
                        title: this.$t('email.oauth_error_title'),
                        message: this.$t('email.oauth_error.' + code),
                    });
                } else {
                    SystemNotificator.success({ title: this.$t('email.oauth_connected'), message: '' });
                }

                this.$router.replace({ query }).catch(() => {});
            },
        },
    }
</script>

<style/>